import "whatwg-fetch"
import React, { Component } from "react"
import { OpenStreetMapProvider } from "leaflet-geosearch"
import {
  KEY_CODE_ENTER,
  iconArrowRight,
  iconSpinner,
  sortLocationsBy,
  fetchLocations,
  GROUPED_LOCATION_IDS,
} from "../../configs"
import Map from "../Map"
import ListItem from "../ListItem"
import "./index.scss"

const geoProvider = new OpenStreetMapProvider({
  params: {
    countrycodes: "dk",
  },
})

class App extends Component {
  typingTimeout = null

  state = {
    searchValue: "",
    isSearching: false,
    enterPressedWhileSearching: false,
    locations: [],
    cycleIndex: -1,
  }

  async componentDidMount() {
    const locations = await fetchLocations()
    this.setState({ locations })
  }

  componentDidUpdate() {
    const { enterPressedWhileSearching, isSearching } = this.state
    if (isSearching) return
    if (enterPressedWhileSearching) {
      this.cycleThruList()
      this.setState({ enterPressedWhileSearching: false })
    }
  }

  handleChangeInput = (event) => {
    this.setState({
      searchValue: event.target.value,
      isSearching: true,
    })

    if (this.typingTimeout) clearTimeout(this.typingTimeout)
    this.typingTimeout = setTimeout(this.fetchGeoLocationAndSortList, 800)
  }

  handleEnterKeyPress = (event) => {
    if (event.keyCode !== KEY_CODE_ENTER) return
    if (this.state.isSearching)
      return this.setState({ enterPressedWhileSearching: true })
    this.cycleThruList()
  }

  cycleThruList = () =>
    this.setState(({ locations, cycleIndex }) => {
      // when cycling thru the list the user want to see a new location each time.
      // However grouped locations has two entries in the list but only appears once on the map
      // so in case the current and next cycleIndex is pointing to the grouped locations
      // we increase the increment to skip the index for the identical location item

      let increment = 1

      const currentLocation = locations[cycleIndex]
      const nextLocation = locations[cycleIndex + 1]

      if (
        currentLocation &&
        nextLocation &&
        ((GROUPED_LOCATION_IDS[0].includes(currentLocation.id) &&
          GROUPED_LOCATION_IDS[0].includes(nextLocation.id)) ||
          (GROUPED_LOCATION_IDS[1].includes(currentLocation.id) &&
            GROUPED_LOCATION_IDS[1].includes(nextLocation.id)))
      )
        increment = 2

      return {
        cycleIndex:
          locations.length === cycleIndex + 1 ? 0 : cycleIndex + increment,
      }
    })

  fetchGeoLocationAndSortList = async () => {
    const { searchValue, locations } = this.state

    // lookup geo locations
    const results = await geoProvider.search({ query: searchValue })
    if (results.length < 1) return this.setState({ isSearching: false })

    // sort locations by geo location
    const { x, y } = results[0]
    const locationsCopy = [...locations]
    locationsCopy.sort(sortLocationsBy(x, y))

    this.setState({
      locations: locationsCopy,
      cycleIndex: -1,
      isSearching: false,
    })
  }

  render() {
    const { searchValue, locations, cycleIndex, isSearching } = this.state
    const locationIdPopupShown =
      cycleIndex === -1 ? null : locations[cycleIndex].id
    return (
      <div className="openStreetMaps">
        <div className="layout">
          <div className="layout__column--short list">
            <div className="list__headline">Find din nærmeste forhandler</div>
            <div className="list__search">
              <input
                type="text"
                placeholder="Indtast by / post nr."
                value={searchValue}
                onChange={this.handleChangeInput}
                onKeyDown={this.handleEnterKeyPress}
              />
              {isSearching || locations.length === 0 ? (
                <button className="disabled">
                  <img src={iconSpinner} draggable={false} alt="" />
                </button>
              ) : (
                <button onClick={this.cycleThruList}>
                  <img src={iconArrowRight} draggable={false} alt="" />
                </button>
              )}
            </div>
            <div className="list__items">
              {locations.map((location) => (
                <ListItem key={location.id} {...location} />
              ))}
            </div>
          </div>
          <div className="layout__column--wide">
            <Map
              locations={locations}
              locationIdPopupShown={locationIdPopupShown}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default App
